export default __webpack_public_path__ + "static/media/character_thumbail5.de294595.png";